var __WEBPACK_NAMESPACE_OBJECT__ = RooPlus.locales['en-US'];